
import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaSignOutAlt,
  FaChartBar,
  FaUsers,
  FaClipboardList,
  FaUserTie,
} from "react-icons/fa";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { MdDashboard, MdSchedule } from "react-icons/md";
import { AiOutlinePlusCircle } from "react-icons/ai";

const AdminLayout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  const activeClass =
    "bg-[#495057] text-white font-semibold shadow-inner";

  const inactiveClass =
    "text-gray-300 hover:bg-[#343a40] hover:text-white transition-all duration-200";

  return (
    <>
      {/* Mobile Toggle Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed top-4 left-4 z-[9999] bg-[#0d2149] text-white p-2 rounded-md md:hidden"
        >
          <FaBars size={20} />
        </button>
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 w-64 bg-[#03153b] text-white h-screen flex flex-col justify-between shadow-2xl 
        transform transition-transform duration-300 z-50
        ${isOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
      >
        <div>
          {/* HEADER */}
          <div className="p-5 border-b border-gray-700 flex items-center justify-between">
            <h2 className="text-2xl font-bold tracking-wide">ADMIN PANEL</h2>

            <button
              onClick={() => setIsOpen(false)}
              className="md:hidden text-gray-300 hover:text-white"
            >
              <FaTimes size={20} />
            </button>
          </div>

          {/* NAVIGATION */}
          <nav className="flex flex-col mt-4 space-y-1 text-[16px]">
  <NavItem to="/admin/dashboard" icon={<MdDashboard size={18} />} label="Dashboard"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/venues" icon={<HiOutlineBuildingOffice2 size={18} />} label="Venues"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/venues/add" icon={<AiOutlinePlusCircle size={18} />} label="Add Venue"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/coaches" icon={<FaUserTie size={18} />} label="Coaches"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/courtowners" icon={<FaUserTie size={18} />} label="Court Owners"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/bookings" icon={<FaUsers size={18} />} label="Users"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/allbookings" icon={<FaClipboardList size={18} />} label="Bookings"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/slots" icon={<MdSchedule size={18} />} label="Manage Slots"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/blockslots" icon={<MdSchedule size={18} />} label="Block Slots"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/reports" icon={<FaChartBar size={18} />} label="Reports"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/courtowners/approvals" icon={<MdSchedule size={18} />} label="Court Owner Approvals"
    onClick={() => setIsOpen(false)} />

  <NavItem to="/admin/blocked-users" icon={<FaUsers size={18} />} label="Locked Users"
    onClick={() => setIsOpen(false)} />
</nav>

        </div>

        {/* LOGOUT BUTTON */}
        <div className="p-5 border-t border-gray-700">
          <button
            onClick={logout}
            className="w-full flex items-center justify-center gap-2 bg-red-600 text-white py-2 rounded-md hover:bg-red-700 transition-all font-semibold text-lg"
          >
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <main className="flex-1  bg-gray-200 min-h-screen md:ml-64">
        <Outlet />
      </main>
    </>
  );
};

/* 🎨 Reusable NavItem */
const NavItem = ({ to, icon, label, onClick }) => {
  return (
    <NavLink
      to={to}
      end
      onClick={onClick}   // 👈 CLOSE SIDEBAR ON CLICK
      className={({ isActive }) =>
        `flex items-center gap-3 px-5 py-2 rounded-md ${
          isActive
            ? "bg-[#495057] text-white font-semibold shadow-inner"
            : "text-gray-300 hover:bg-[#343a40] hover:text-white transition-all"
        }`
      }
    >
      {icon}
      {label}
    </NavLink>
  );
};


export default AdminLayout;
